import React from 'react';

const MealEntryServingEditor = ({
  servings,
  setServings,
  onSave,
  disabled = false,
}) => {
  return (
    <div className="flex justify-between items-center gap-4">
      <div className="flex items-center gap-3 text-sm">
        <span className="font-medium">Servings:</span>
        <button
          onClick={() => setServings(Math.max(1, servings - 1))}
          className="px-2 py-1 bg-gray-200 rounded"
        >
          −
        </button>
        <span>{servings}</span>
        <button
          onClick={() => setServings(servings + 1)}
          className="px-2 py-1 bg-gray-200 rounded"
        >
          +
        </button>
      </div>

      <button
        onClick={onSave}
        className="
                inline-flex
                items-center
                justify-center
                gap-1
                px-3
                py-2
                bg-black
                text-white
                rounded-full
                font-medium
                hover:bg-gray-800
                transition
                "
      >
        Save
      </button>
    </div>
  );
};

export default MealEntryServingEditor;
